import {Injectable, Injector} from "@angular/core";
import {CustomObjectTypeEntityModel} from "./custom-object-type-entity.model";
import {CustomObjectTypeData} from "./custom-object-type.data";

@Injectable()
export class OutletCustomObjectTypeEntityModel extends CustomObjectTypeEntityModel {
    constructor(injector: Injector) {
        super(injector);
    }

    override getResource(): string {
        return "custom-outlet-group-type";
    }

    protected override onNewEntity(entityData: CustomObjectTypeData): void {
        super.onNewEntity(entityData);
        entityData.outletContext = true;
    }
}
